import './social_content_header_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentReviewCommentHeaderView extends Monitoring.Views.SocialContents.SocialContentHeaderView
  templateOptions: ->
    options = _.extend({}, super, subtype: 'Review comment');
    options
